<template>
  <div class="inner">
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">처방문의 관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>처방문의</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control"
                  v-model="searchInfo.inquiry_details"
                />
              </li>
              <li>
                <p>주소증</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control"
                  v-model="searchInfo.chief_complaint"
                />
              </li>
              <li>
                <p>카테고리</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.prescribe_category" style="width: 310px">
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="50" />
                <col width="150" />
                <col width="300" />
                <col width="100" />
                <col width="100" />
                <col width="*" />
                <col width="150" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>카테고리</th>
                  <th>처방문의</th>
                  <th>성별</th>
                  <th>나이</th>
                  <th>주소증</th>
                  <th>노출여부</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="formulaQnaList.length == 0">
                    <td colspan="7"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in formulaQnaList" :key="index" @click="fn_move_dtl_page(item.formula_inquiry_seq)">
                  <td>
                    <span><span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span></span>
                  </td>
                  <td>
                      <span>{{ item.prescribe_category_nm }}</span>
                  </td>
                  <td>
                    <span>{{ item.inquiry_details }}</span>
                  </td>
                  <td>
                    <span>{{ item.age }}</span>
                  </td>
                  <td>
                    <span>{{ item.gender_nm }}</span>
                  </td>
                  <td class="al">
                    <span>{{ item.chief_complaint }}</span>
                  </td>
                  <td>
                    <span>{{ item.display_yn }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"
import commonUtil from "@/mixin/commonUtil";

export default {
  name: "FormulaQnaMngt",
  components: {
    Pagination,
  },
  mixins: [commonUtil],
  data() {
    return {
    searchInfo : {
          inquiry_details : '',
          chief_complaint : '',
          prescribe_category : '',
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }                
      },
      formulaQnaList: [],
      prescrbeCategoryList : [],
      pagingShow : false
    };
  },
  async created(){
      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore
      }
      
      //처방 카테고리
      this.prescrbeCategoryList = await this.getCode('GC00000015'); 

      this.fn_search();
  },
  methods : {
    fn_search(){

        this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

        axios
            .post("/api/admin/contents/getFormulaQnaMngtList", this.searchInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);                    
                this.formulaQnaList = res.data.formulaQnaMngtList;
                

                console.log("@@@@ formulaQnaList : %o",this.formulaQnaList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                    
            })
            .catch((err) => console.log(err));
    },
    movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
    },
    fn_move_dtl_page(seq){
        this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
        this.$router.push({ name : 'FormulaQnaMngtDetail'});
    },
  }
};
</script>
